import request from '@/router/axios'
import env from '@/config/env'

// 获取合同分类
export const kindList = (params) => {
  return request({
    url: `${env.officeUrl}/contract-kind/v1/kind-list`,
    method: 'get',
    params
  })
}
// 合同分类新增或编辑
export const addOrEdit = (params) => {
  return request({
    url: `${env.officeUrl}/contract-kind/v1/save-or-update`,
    method: 'post',
    data: params
  })
}
// 模版列表
export const list = (params) => {
  return request({
    url: `${env.officeUrl}/contract-template/v1/page`,
    method: 'post',
    data: params
  })
}
// 新增或编辑模版
export const saveUpdate = (params) => {
  return request({
    url: `${env.officeUrl}/contract-template/v1/save-or-update`,
    method: 'post',
    data: params
  })
}
// 删除
export const kindDel = (params) => {
  return request({
    url: `${env.officeUrl}/contract-kind/v1/delete`,
    method: 'delete',
    params
  })
}
// 删除
export const templateDel = (params) => {
  return request({
    url: `${env.officeUrl}/contract-template/v1/delete`,
    method: 'delete',
    params
  })
}

// 合同审核=======================================================
// 分页
export const approveList = (params) => {
  return request({
    url: `${env.officeUrl}/contract-approve/v1/page`,
    method: 'post',
    data: params
  })
}
// 新增或编辑
export const approveAddOrEdit = (params) => {
  return request({
    url: `${env.officeUrl}/contract-approve/v1/save-or-update`,
    method: 'post',
    data: params
  })
}
// 获取编辑详情
export const detail = (params) => {
  return request({
    url: `${env.officeUrl}/contract-approve/v1/detail/${params}`,
    method: 'get'
  })
}
// 提交审核
export const submitApprove = (params) => {
  return request({
    url: `${env.officeUrl}/contract-approve/v1/submit-approve`,
    method: 'post',
    data: params
  })
}
// 撤回审核
export const withdrawal = (params) => {
  return request({
    url: `${env.officeUrl}/contract-approve/v1/withdrawal`,
    method: 'post',
    data: params
  })
}
// 审核通过-审核不通过
export const approve = (params) => {
  return request({
    url: `${env.officeUrl}/contract-approve/v1/approve`,
    method: 'post',
    data: params
  })
}

// 合同台帐=======================================================
// 分页
export const standingBookPage = (params) => {
  return request({
    url: `${env.officeUrl}/contract/v1/page`,
    method: 'post',
    data: params
  })
}
// 获取履行状态可变更状态列表
export const contractNextStatus = (params) => {
  return request({
    url: `${env.officeUrl}/contract/v1/contract-next-status`,
    method: 'get',
    params
  })
}
// 详情
export const stadingBookDetail = (params) => {
  return request({
    url: `${env.officeUrl}/contract/v1/detail/${params}`,
    method: 'get'
  })
}
// 新增或编辑
export const stadingAddOrEdit = (params) => {
  return request({
    url: `${env.officeUrl}/contract/v1/save-or-update`,
    method: 'post',
    data: params
  })
}
// 详情
export const stadingDetail = (params) => {
  return request({
    url: `${env.officeUrl}/contract/v1/detail/${params}`,
    method: 'get'
  })
}
